import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import NewsItemForm from '../../../components/forms/NewsItemForm';
import { useNewsItemApi } from '../../../hooks/useNewsItemApi';
import { useNavigate, useParams } from 'react-router-dom';
import { NewsItemDTO } from '../../../services/apiClient';

const NewsItemEdit: React.FC = () => {
  const { getById, edit } = useNewsItemApi();
  const [entityData, setEntityData] = useState<NewsItemDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'News Items', href: '/admin/newsitems' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching NewsItem data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/newsitems');
    } catch (error) {
      console.error('Error updating NewsItem:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/newsitems"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Content.NewsItem.Edit'
    >
      {entityData ? (
        <NewsItemForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/newsitems')}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default NewsItemEdit;